import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';

// Firebase web-config är publik per design (Firebase Auth-arkitektur exponerar
// dessa i klient-bundle:n oavsett — säkerheten ligger i blocking triggers,
// allowlist och backend-API). Importerade från Firebase Console:
// firebase.googleapis.com/v1beta1/projects/w6-event-manager/webApps/.../config
const firebaseConfig = {
  apiKey: 'AIzaSyCxajn7TeQe_s4VzkfX80anCYwg_qGCp_M',
  // Custom domain som primary authDomain → same-origin auth på mobil.
  // (Tidigare använde vi web.app av samma skäl; nu kör vi den riktiga domänen.)
  authDomain: 'program.stamlogen2026.w6.se',
  projectId: 'w6-event-manager',
  storageBucket: 'w6-event-manager.firebasestorage.app',
  messagingSenderId: '829216196551',
  appId: '1:829216196551:web:454648e1f0194a3aebfbe2',
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
// Skickar Firebase Auth-mail på svenska. Templates och avsändare
// (rubrik, brödtext, från-adress) konfigureras i Firebase Console
// → Authentication → Templates → välj svenska.
auth.languageCode = 'sv';

if (import.meta.env.VITE_USE_EMULATOR === 'true') {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
}
